/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Drawer as RWDrawer } from "@revenuewell/ui-drawers";
import { DrawerSection } from './drawer-section';
import { DrawerButton } from './drawer-button';
import { useLayout } from './layout';
import { useNavigation } from '@revenuewell/logic-navigation';
import AllInboxOutlinedIcon from '@mui/icons-material/AllInboxOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import { ListItemIcon, useMediaQuery, useTheme } from '@mui/material';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import { makeStyles } from "@mui/styles";
import { useSubmissionStatsContext } from '../../context/submission-stats-context';
import classNames from 'classnames';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { DrawerContent } from './drawer-content';
import { HelpContentWidget } from '../shared/help-content'
import TabletMacOutlinedIcon from '@mui/icons-material/TabletMacOutlined';
import { useAppContext } from '../../context/app-context';
import PinDialog from '../shared/pin-dialog';
import { useSelectedLocation } from '../../hooks/use-selected-location';


/* eslint-disable-next-line */
export interface IDrawerProps { }

const useStyles = makeStyles(theme => ({
    subMenu: {
        marginLeft: '25px'
    }
}))


export function Drawer(props: React.PropsWithChildren<IDrawerProps>) {
    const { menuFocus, setMenuFocus } = useLayout();
    const navigation = useNavigation();
    const location = useLocation();
    const { unreadSubmissionCount } = useSubmissionStatsContext();
    const classes = useStyles();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
    const { goToPatientApp } = useAppContext();
    const [openPinDialogue, setOpenPinDialogue] = useState(false);
    const { selectedLocation } = useSelectedLocation();

    const renderActiveState = (path: string) => {
        return location.pathname.indexOf(path) > 0 ? "active" : "";
    }

    const isSettingsActive = () => {
        return location.pathname.indexOf("forms") > 0 || location.pathname.indexOf("packets") > 0;
    }

    const onDrawerButtonClick = (path: string) => {
        setMenuFocus('content');
        navigation.push('/' + path);
    }

    return (
        <>
            <RWDrawer focused={menuFocus == "drawer"}>
                <DrawerContent>
                    <div>
                        <DrawerSection>
                            <DrawerButton title="Patients"
                                id="library"
                                onClick={() => onDrawerButtonClick("submissions/index")} >
                                <ListItemIcon><Person2OutlinedIcon /></ListItemIcon>
                            </DrawerButton>
                            <DrawerButton title="Submissions"
                                id="submissions"
                                className={classNames(renderActiveState("submissions"), classes.subMenu)}
                                onClick={() => onDrawerButtonClick("submissions/index")}
                                badgeCount={unreadSubmissionCount} >
                                <ListItemIcon><AllInboxOutlinedIcon /></ListItemIcon>
                            </DrawerButton>
                            <DrawerButton title="Assignments"
                                id="assignments"
                                className={classNames(renderActiveState("assignments"), classes.subMenu)}
                                onClick={() => onDrawerButtonClick("assignments/index")} >
                                <ListItemIcon><AssignmentIndOutlinedIcon /></ListItemIcon>
                            </DrawerButton>
                            <DrawerButton title="Settings"
                                id="settings"
                                onClick={() => onDrawerButtonClick("forms/index")}>
                                <ListItemIcon><SettingsOutlinedIcon /></ListItemIcon>
                            </DrawerButton>
                            {isSettingsActive() &&
                                <>
                                    <DrawerButton title="Forms"
                                        id="library"
                                        className={classNames(renderActiveState("forms"), classes.subMenu)}
                                        onClick={() => onDrawerButtonClick("forms/index")} >
                                        <ListItemIcon><LibraryBooksOutlinedIcon /></ListItemIcon>
                                    </DrawerButton>
                                    <DrawerButton title="Packets"
                                        id="packets"
                                        className={classNames(renderActiveState("packets"), classes.subMenu)}
                                        onClick={() => onDrawerButtonClick("packets/index")} >
                                        <ListItemIcon><AssignmentOutlinedIcon /></ListItemIcon>
                                    </DrawerButton>
                                </>
                            }
                            <DrawerButton title="Tablet"
                                id="tablet"
                                onClick={() => setOpenPinDialogue(true)}>
                                <ListItemIcon><TabletMacOutlinedIcon /></ListItemIcon>
                            </DrawerButton>
                        </DrawerSection>
                    </div>
                    <HelpContentWidget app="forms2" context=""></HelpContentWidget>
                </DrawerContent>
            </RWDrawer>

            <PinDialog title='Create your PIN' subtitle='To ensure that only authorized office employees can access sensitive data, please create a PIN to return to Assignments after your patient is done filling out their forms.' showCloseIcon
                open={openPinDialogue}
                handlePinContinueToForms={() => goToPatientApp(selectedLocation.locationId)}
                handleClose={() => setOpenPinDialogue(false)}
                cancelText='Cancel' />        </>

    );
}

